import { rollbar } from "@/lib/rollbar"

export const logger = {
  error(error: unknown, context?: Record<string, unknown>) {
    if (process.env.NODE_ENV === "development") {
      console.error(error, context)
    }
    rollbar.error(error as Parameters<typeof rollbar.error>[0], context as any)
  },
}
